export default "__VITE_ASSET__vkrtNMxh__"